/* Copyright (c) 2020 Paul Nebel */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as styles from '../styles/components.module.css';

class EventButton extends React.PureComponent {
    addButtonContents() {
        return (
            <span className='is-size-5'>{ this.props.text }</span>
        );
    }

    handleClicked() {
        this.props.notifyButtonClicked(this.props.event);
    }

    render() {
        const {
            variant,
        } = this.props;
        return (
            <button
                className={ `button ${ variant } is-rounded ${ styles.playerButton }` }
                onClick={ this.handleClicked.bind(this)  }
                disabled={ this.props.disabled }
            >
                { this.addButtonContents() }
            </button>
        );
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        notifyButtonClicked: (
            event,
        ) => dispatch({
            type: `BUTTON_CLICKED`,
            event,
        }),
    };
};

EventButton.propTypes = {
    variant: PropTypes.string,
    event: PropTypes.string,
    notifyButtonClicked: PropTypes.func,
    text: PropTypes.string,
    disabled: PropTypes.bool,
};

EventButton.defaultProps = {
    variant: 'is-info',
    event: 'default',
    text: 'I',
    disabled: false,
};

export const component = connect(
    null,
    mapDispatchToProps,
)(EventButton);

export const obj = EventButton;